import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { ListingSort } from '@df/catalog-ui/listing/sort/listing-sort';
import { KlevuSearchService } from '@df/module-klevu-search/klevu-search.service';
import { ListingSortKlevuEngine } from '@df/module-klevu-search/listing-sort-klevu.engine';
import { SearchService } from '@df/search/search.service';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NDfModuleKlevuSearch } from './klevu-search.namespace';
import { KlevuTrackService } from './klevu-track.service';

export function provideDfModuleKlevuSearch(config?: DeepPartial<NDfModuleKlevuSearch.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders([
        { provide: SearchService, useExisting: KlevuSearchService },
        {
            provide: NDfModuleKlevuSearch.OPTIONS,
            useFactory: () => defaultsDeep(config, NDfModuleKlevuSearch.DEFAULT_OPTIONS)
        },
        provideAppInitializer(() => {
            const listingSortKlevuEngine = inject(ListingSortKlevuEngine);

            ListingSort.engines['klevu'] = listingSortKlevuEngine;

            inject(KlevuTrackService).appInitialize();
        })
    ])
}